module.exports = __webpack_public_path__ + "static/media/iu_logo.7e30916d.png";